import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { trackEvent } from "../../appInsights/TelemetryService";
import { useSelector, useDispatch } from "react-redux";
import Property from "../../models/Property";
import { PremisesType } from "../../models/Customer/Premises";
import * as api from "../../api";
import { assetData, saveAssociatedAssests, saveCustomerphoneNumber, selectedTenacyType } from "../../ducks/redux/actions/getAddress";
import { PermissionsList } from "../../models/Permissions";
import { Address, Assets, PostalAddress } from "../../models/Property/PropertyResponse";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import { hierarchyOfPremises, woFailureCase } from "../../ducks/redux/actions/userChoices";
import { assetArrayDispatch, assetBackCouterDispatch, storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import assetHierarchyImg from '../../assets/icons/assetHierarchy.png';
import '../../utils/commonCss/icons.css'
import useBackToTop from "../BackToTop/useBackToTop";
import { priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import { addAPIError, removeAPIError} from "../../utils/translation/helper";
import { getAssetsById, getAssociatedAssets } from "../APIErrorComponent/APIConstantName";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";


interface AssetCardAsset360Props extends RouteComponentProps<any> {
    errorFlag: boolean;
}
const AssetCardAsset360: React.FC<AssetCardAsset360Props> = (props) => {
    const { t } = useTranslation();
    let {errorFlag} = props;
    const dispatch = useDispatch();
   const[apiErrorcheck, setApiErrorcheck] = useState(false);
    const assetDetails = useSelector(
        (state: any) =>
          state?.dashboardReducer?.formState?.assetByIdDataObject
      );
    const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
        
    let assetStatus = useSelector(
        (state: any) => state?.userChoicesReducer?.assetDataStatus
    );
    const customerResponse = useSelector(
        (state: any) => state?.addresses?.saveCustomerDetails
    );
    const isActiveTenancy = useSelector(
        (state: any) => state?.userChoicesReducer?.isActiveTenancy
    );
    const isP360Maintainence = useSelector(
        (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
      );
    const array: Property[] = [];
    const [propertyList, setPropertyList] = useState(array);
    const [propertyLength, setPropertyLength] = useState(0);
    const [dropDown, setDropDown] = useState("none");
    const [assetType, setAssetType] = useState("");
    const {width} = useBackToTop();
    const assetDataDetails = useSelector((state: any) => state?.addresses?.assetData);
    let counter = useSelector((state:any) => state?.financialReferralReducer?.assetBackCounter);
    const getPermissionsData = useSelector(
        (state: any) => state?.userChoicesReducer?.userProfilePermissions
    );
    
      
    const currentAssetEligibilityDetails = useSelector(
        (state: any) => state?.addresses?.currentAssetEligibilityDetails);

    useEffect(() => {
        (async () => {
            trackEvent("AssetCardAsset360");
            let associtaedAssets: any[] = [];
            const premisesList: Property[] = [];
            try {
            const associatedAssetsResponse = assetDetails?.id? await api.getAssociatedAssets(assetDetails?.id):[];
            dispatch(storeAPIErrors( removeAPIError(getAssociatedAssets, errors)));
            setApiErrorcheck(false)
            associtaedAssets.push(associatedAssetsResponse);
            dispatch(saveAssociatedAssests(associtaedAssets));
            if (associatedAssetsResponse !== null && associatedAssetsResponse !== undefined) {
                associatedAssetsResponse?.forEach((element: any) => {
                    if (element.assetType !== PremisesType.Scheme && element.assetType !== PremisesType.EstateArea && element.assetType !== PremisesType.Default) {
                        if (element.id === assetDetails?.id) {
                            if (element.assetType === PremisesType.Property) {
                                dispatch(selectedTenacyType(element.assetType));
                                setAssetType(element.assetType);
                                associatedAssetsResponse?.forEach((el: any) => {
                                    const premisesEntry: Property = new Property();
                                    premisesEntry.premisesType = el.assetType as PremisesType;
                                    premisesEntry.uprn = el.uprn;
                                    premisesEntry.id = el.id;
                                    premisesEntry.address = el?.addresses?.postalAddresses[0];
                                    if (el.assetType === PremisesType.DividedBlock || el.assetType === PremisesType.Block || el.assetType === PremisesType.Estate) {
                                        premisesList.push(premisesEntry);
                                    }

                                });
                            }
                            else if (element.assetType === PremisesType.DividedBlock) {
                                dispatch(selectedTenacyType(element.assetType));
                                setAssetType(element.assetType);
                                associatedAssetsResponse?.forEach((el: any) => {
                                    const premisesEntry: Property = new Property();
                                    premisesEntry.premisesType = el.assetType as PremisesType;
                                    premisesEntry.uprn = el.uprn;
                                    premisesEntry.id = el.id;
                                    premisesEntry.address = el?.addresses?.postalAddresses[0];
                                    if (el.assetType === PremisesType.Block || el.assetType === PremisesType.Estate) {
                                        premisesList.push(premisesEntry);
                                    }

                                });
                            }
                            else if (element.assetType === PremisesType.Block) {
                                dispatch(selectedTenacyType(element.assetType));
                                setAssetType(element.assetType);
                                associatedAssetsResponse?.forEach((el: any) => {
                                    const premisesEntry: Property = new Property();
                                    premisesEntry.premisesType = el.assetType as PremisesType;
                                    premisesEntry.uprn = el.uprn;
                                    premisesEntry.id = el.id;
                                    premisesEntry.address = el?.addresses?.postalAddresses[0];
                                    if (el.assetType === PremisesType.Estate) {
                                        premisesList.push(premisesEntry);
                                    }

                                });
                            }
                            else if (element.assetType === PremisesType.Estate) {
                                dispatch(selectedTenacyType(element.assetType));
                                setAssetType(element.assetType);
                            }
                        }
                    }
                });
                
                setPropertyList(premisesList);
                dispatch(hierarchyOfPremises(premisesList));
            }
            setPropertyLength(premisesList?.length);  
            }
            catch (e) {
                dispatch(storeAPIErrors(addAPIError(getAssociatedAssets, errors))) ;
                console.error(e);
                setApiErrorcheck(true);
              }
        })();
    }, [assetDetails]);

    const callProperty360 = (propertyData: Property) => {
        if (counter === 0){
            dispatch(assetArrayDispatch(assetDataDetails))
        }
        dispatch(assetBackCouterDispatch(counter+1))
        counter = counter + 1;
        const assetEntry: Assets = new Assets();
        assetEntry.assetType = propertyData?.premisesType
        assetEntry.uprn = propertyData?.uprn
        assetEntry.id = propertyData?.id
        const addressEntry: Address = new Address();
        const postalAddressEntry: PostalAddress = new PostalAddress();
        postalAddressEntry.addressLine1 = propertyData?.address?.addressLine1
        postalAddressEntry.addressLine2 = propertyData?.address?.addressLine2 != null ? propertyData?.address?.addressLine2 : ""
        postalAddressEntry.addressLine3 = propertyData?.address?.addressLine3 != null ? propertyData?.address?.addressLine3 : ""
        postalAddressEntry.addressLine4 = propertyData?.address?.addressLine4 != null ? propertyData?.address?.addressLine4 : ""
        postalAddressEntry.addressLine5 = propertyData?.address?.addressLine5 != null ? propertyData?.address?.addressLine5 : ""
        postalAddressEntry.postcode = propertyData?.address?.postcode
        postalAddressEntry.id = propertyData?.address?.id
        addressEntry.postalAddresses.push(postalAddressEntry);
        assetEntry.addresses = addressEntry
        dispatch(assetData(assetEntry))
        dispatch(assetArrayDispatch(assetEntry))
        globalThis.location.reload();
        
    }

    const dropDownFunction = () => {
        if (dropDown === "none")
            setDropDown("block");
        else
            setDropDown("none");
    }
    const callPageHandler = () => {
        if(!isP360Maintainence){
      dispatch(selectedTenacyType(assetType));
      dispatch(woFailureCase());
      dispatch(priorityCode(''));
      if(isNullOrUndefined(customerResponse?.addresses?.telecomsAddresses)) {
      dispatch(saveCustomerphoneNumber(null));
      }
      else {
        dispatch(saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses));
     } 
        props.history.push("/RepairAsset", { previousPathname: globalThis.location.pathname } );
    }
    };
   const showRepair = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.create_repair_standard);
   const isRepairEnabled = showRepair !== -1 && (assetType && (assetType === "Property" ? (isActiveTenancy || (assetStatus === 'OCCP' || assetStatus === 'VOID')) : true));
    return (
        <div>
            <div className="px-4 py-2 border-b border-grey  bg-teal rounded-t-lg">
                <div className="flex flex-row d-flex bd-highlight items-center">
                <img src={assetHierarchyImg} className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="" />
                    <h2 className="my-0 text-white bd-highlight">{t("Asset_hierarchy")}</h2>
                   
                    
                    {  isRepairEnabled && currentAssetEligibilityDetails?.isEligibleToRaiseARepair ? (
                                <div className="menu-nav ms-auto bd-highlight">
                                    <div className="dropdown-container">
                                        <div className="three-dots kebabMenu" data-testid="dropFunction" onClick={dropDownFunction}></div>

                                        <div className="dropdown px-2 dropdown-margin py-2" style={{ display: dropDown }}>
                                            <a onClick={callPageHandler} onKeyPress={callPageHandler}data-testid="callHandler" className="text-black text-base no-underline global-txt"><div className={"py-2 cursor-pointerpy-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>{assetType === "Property"|| assetStatus === 'OCCP' || assetStatus === 'VOID' ? t("Create_repair") :  t("raise_comm") }</div></a>
                                        </div>
                                    </div>
                                </div>
                            
                        ) : null
                    }
                   
                </div>
            </div>

            {propertyLength ? (<>
                {propertyList && propertyList.length > 0 && propertyList?.map((property) => (
                    <div className="px-4 mt-4" key={property.id}>
                    <div className="border border-grey rounded-lg bg-grey global-txt">
                        <div className="bg-peach px-4 py-2 rounded-t-lg">
                            <div className={width<820?"items-center":"flex flex-row justify-between items-center "}>
                                <div className="my-0 text-lg ">
                                <strong> <a data-testid="callProperty" onKeyPress={() => callProperty360(property)} onClick={() => callProperty360(property)} role="button" className="text-dark cursor-pointer">
                                       {t("UPRN")} {property?.uprn}</a></strong></div>
                                <div className="my-0 text-lg"><strong>{property?.premisesType}</strong></div>
                            </div>
                        </div>

                        <div className="px-4 py-2">
                            <div className="pr-4">{property?.premisesType !== PremisesType.Property ? (
                               <b> {t("Name")}</b>) : <b>{t("Address")}</b>}
                            </div>
                            <div>{property?.premisesType !== PremisesType.Property ?
                                (property?.address?.addressLine1) : (property?.address?.formattedAddress)}</div>
                        </div>
                    </div>
                    </div>
                ))
                }
            </>) : (!apiErrorcheck && !errorFlag && propertyList.length === 0? <div className="px-4 py-4">{t("CP116")}</div>
            :<><div className="px-4 py-2">
                   <div className="border border-grey rounded-lg bg-grey">
                      <div className="bg-peach px-4 py-2 rounded-t-lg">
                     <div className={width<820?"items-center":"flex flex-row justify-between items-center "}>
                          <div className="my-0 text-lg">
                              <strong>{t("UPRN")} {"-"}</strong></div>
                          <div className="my-0 text-base global-txt"><strong>{"-"}</strong></div>
                        </div>
                      </div>
            
                      <div className="px-4 py-2">
                        <div className="pr-4 global-txt">
                           <b>{t("Address")}</b>
                        </div>
                        <div className="global-txt">  {"-"}</div>
                      </div>
                    </div>
                    </div>
                  </>)
            
            }
           
             <ErrorComponent input={[getAssociatedAssets, getAssetsById ]} />
        </div>
    )
};
export default AssetCardAsset360;